import React from "react";
import Commons from "oc-commons/Commons";
import Select from "../commons/Select";
import SidebarFrame from "./SidebarFrame";
import OptionInput from "../commons/OptionInput";
import DekorInput from "../commons/DekorInput";
import CheckboxInput from "../commons/CheckboxInput";
import RadioGroup from "../commons/RadioGroup";
import ReactPaginate from "react-paginate";
import SchrankInput from "../commons/SchrankInput.jsx";
import MeasureNumberInput from "../commons/MeasureNumberInput.js";

export default class SockelSettings extends SidebarFrame {
    constructor(params) {
        super(params);
        this.params = params;
    }
    
    state = {
        sockelOption: APP.arrangement.selectedSchrank.sockelOption,
        sockelHoehe: APP.arrangement.selectedSchrank.sockelHoehe
    }
    

    sockelEnabled() {
        const currentSchrankModellName = APP.arrangement.schraenke[APP.arrangement.currentSchrankIndex].modell.Name
        const werte = APP.metadata.Modellwerte[currentSchrankModellName];
        return werte ? werte["sockel"] : false;
    }

    get sockelOptions() {
        return [
            {key: "ohne", label: "ohne", value: "ohne"},
            {key: "nurFront", label: "Sockel mit aufstehenden Seitenwänden", value: "nurFront"},
            {key: "mitBlende", label: "Sockel mit seitlichen Blenden", value: "mitBlende"}
        ]
    }

    get sockelhoeheOptions() {
        const currentSchrankModellName = APP.arrangement.selectedSchrank.modell.Name
        const werte = APP.metadata.Modellwerte[currentSchrankModellName];
        const sockelHoehen = werte ? werte.Sockelhoehen?.Wert.split(',').map(option => {
                return {
                    key: option,
                    label: option + " mm",
                    articlenumber: "sockel_" + option
                }
        }) : [];
        return sockelHoehen;
    }

    renderTitle() {
        return I18N("Sockel");
    }

    get schrankHasInteriors() {
        return APP.arrangement.selectedSchrank.hasInterior;
    }

    render() {
        return (
            <>
                <div className={"appear " + (this.schrankHasInteriors ? "radioHidden" : "") }>
                    <RadioGroup
                        name={"SockelOption"} 
                        label={I18N("SockelOption")}
                        value={this.state.sockelOption}
                        disabled={this.schrankHasInteriors}
                        style={{opacity: 0.8}}
                        onChange={value => {
                            const state = this.state;
                            state.sockelOption = value;
                            if (value != "ohne" && state.sockelHoehe < 0) {
                                state.sockelHoehe = APP.arrangement.selectedSchrank.options.getFloat("minimaleSockelhoehe");
                            }
                            this.setState(state);
                            APP.arrangement.setSockelOptionForSelectedSchrank(value);
                        }}
                        options={this.sockelOptions}
                    />
                    {this.state.sockelOption == "mitBlende" && 
                        <div className="important notice">
                            <label>{I18N("sockel mit Blende Hinweis")}</label>
                        </div>
                    }
                    {this.state.sockelOption != "ohne" && 
                        <MeasureNumberInput
                            key={"SockelHoehe"}
                            label={I18N('Sockelhoehe')}
                            min={this.params.minHoehe}
                            max={this.params.maxHoehe}
                            disabled={this.schrankHasInteriors}
                            value={this.state.sockelHoehe}
                            onCommit={(value) => {
                                const state = this.state;
                                state.sockelHoehe = value;
                                this.setState(state);
                                APP.arrangement.setSockelHoeheForSelectedSchrank(value);
                            }}
                        />

                    }
                    {this.schrankHasInteriors && 
                        <div className="important notice" style={{opacity: 1.0}}>
                            <label>{I18N("schrank hat Interieur")}</label>
                        </div>
                    }
                </div>
            </>
        )
    }
}
